import { computed, unref, watch } from 'vue';
import { useI18n } from 'vue-i18n';
import { useMapGetter } from 'dashboard/composables/store';
import { useUISettings } from 'dashboard/composables/useUISettings';

// O idioma de quem está logado nas telas que não são de uma conta — as rotas `accountAgnostic`,
// como a entrada da equipe no link de teste (`/app/test-link`) e o consentimento do OAuth.
//
// Dentro de uma conta, o `App` usa a preferência da pessoa ou o idioma da conta
// (`initializeAccount`). Fora, não havia conta de onde tirar o idioma, e a tela ficava no padrão da
// instalação — em inglês para quem usa o painel em português (L-21). Aqui vale a mesma régua: a
// preferência da pessoa e, sem ela, o idioma da conta ativa dela.
export const idiomaDoUsuario = (usuario, uiSettings) => {
  const ativa = (usuario?.accounts || []).find(
    conta => conta.id === usuario?.account_id
  );
  return uiSettings?.locale || ativa?.locale || null;
};

// `contaAtual` é o id da conta da rota; fora de uma conta ele não existe, e o idioma segue a pessoa
// assim que ela é carregada.
export function useIdiomaForaDaConta(contaAtual) {
  const { locale } = useI18n({ useScope: 'global' });
  const usuario = useMapGetter('getCurrentUser');
  const { uiSettings } = useUISettings();

  const idioma = computed(() =>
    unref(contaAtual) ? null : idiomaDoUsuario(usuario.value, uiSettings.value)
  );

  watch(
    idioma,
    novo => {
      if (novo) locale.value = novo;
    },
    { immediate: true }
  );

  return { idioma };
}
